import { createAction, props } from '@ngrx/store';
import { IFermenter } from 'app/models/fermenter';

export const clearAllItems = createAction('[DalHelper] Clear All Fermenters');
export const loadItems = createAction('[Fermenter Page] Load Fermenters', props<{ barId: string; forceRefresh?: boolean }>());
export const loadItemsFailure = createAction('[Fermenter API] Load Fermenters Failure', props<{ error: any }>());
export const loadItemsSuccess = createAction('[Fermenter API] Load Fermenters Success', props<{ items: IFermenter[] }>());

export const updateItem = createAction('[Fermenter Detail Page] Update Fermenter', props<{ item: IFermenter }>());
export const updateItemSuccess = createAction('[Fermenter API] Update Fermenter Success', props<{ item: IFermenter }>());
export const updateItemFailure = createAction('[Fermenter API] Update Fermenter Failure', props<{ error: any }>());

export const addItem = createAction('[Fermenter Detail Page] Add Fermenter', props<{ id: string, item: IFermenter }>());
export const addItemSuccess = createAction('[Fermenter API] Add Fermenter Success', props<{ item: IFermenter }>());
export const addItemFailure = createAction('[Fermenter API] Add Fermenter Failure', props<{ error: any }>());

export const deleteItem = createAction('[Fermenter Detail Page] Delete Fermenter', props<{ id: string }>());
export const deleteItemSuccess = createAction('[Fermenter API] Delete Fermenter Success');
export const deleteItemFailure = createAction('[Fermenter API] Delete Fermenter Failure', props<{ error: any }>());

export const setItem = createAction('[Fermenter Detail Page] Set Selected Item', props<{ id: string }>());
export const setItemAndNavigate = createAction('[Fermenter Detail Page] Set Selected Item And Navigate', props<{ id: string }>());
export const setItemFromListPage = createAction('[Fermenter List Page] Set Selected Item', props<{ id: string }>());

export const softUpdate = createAction('[Fermenter API] Soft Update Fermenter', props<{ id: string, data: any, uid: string }>());
export const softUpdateSuccess = createAction('[Fermenter API] Soft Update Fermenter Success', props<{ id: string, data: any }>());
export const softUpdateFailure = createAction('[Fermenter API] Soft Update Fermenter Failure', props<{ error: any }>());
